import { formatISO } from "date-fns";
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BriefDateDropdown from "../../components/BriefDropDownList/BriefDateDropdown";
import Button from '../../components/Button/Button';
import DocumentListItem from '../../components/HalfPage_Popup/DocumentListItem';
import Loader from '../../components/Loader/Loader';
import NoResultsComponent from '../../components/NoResults/NoResult';
import HorizontalOptionButtons from '../../components/OptionButtons/HorizontalOptionButtons';
import PopUp from '../../components/PopUp/PopUp';
import Toast from "../../components/Toast/Toast";
import { Globals as OldGlobals } from '../../global/Globals';
import { fetchHalfPageBreif, smEvaluationProposalData, unSolicatedProposalUpdate, fetchDraftedSMEvalScores } from '../../services/api';
import axios from '../../services/axiosInstance';
import { formatCurrency, formatDate } from '../../util/util';
import './SeniorManagerPage.css';
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
import TextArea from "../../components/TextArea/TextArea";

export default function SmEvaluationPage() {
    const { Globals } = useLanguage();
    const roleID = CryptoUtils.getFromLocalStorage("roleId");
    const navigate = useNavigate();
    const location = useLocation();
    const item = location?.state?.activeHeader || '';
    const proposalPage = location?.state?.selectedProposal || ''
    const isVirtualPitchCompleted = location?.state.isVirtualPitchCompleted || ''
    const [text, setText] = useState("");
    const [charCount, setCharCount] = useState(0);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [criterias, setCriterias] = useState();

    const [isSynopsisExpanded, setIsSynopsisExpanded] = useState(false);
    const [contentData, setContentData] = useState([]);
    const [data, setData] = useState([]);
    const [proposalData, setProposalData] = useState(null);
    const [isLogLineExpanded, setIsLogLineExpanded] = useState(false);
    const [isepisodeStructureExpanded, setEpisodeStructureExpanded] = useState(false);
    const [isEditorialExpanded, setIsEditorialExpanded] = useState(false);
    const [isprojectStatusExpanded, setProjectStatusExpanded] = useState(false);
    const [isbrandIntegrationExpanded, setBrandIntegrationExpanded] = useState(false);
    const [isCompanyProfileExpanded, setCompanyProfileExpanded] = useState(false);
    const [iscastPresenterInfoExpanded, setCastPresenterInfoExpanded] = useState(false);
    const [islocationStudioInfoExpanded, setLocationStudioInfoExpanded] = useState(false);
    const [fileItems, setFileItems] = useState([]);
    const [contentDataStatus, setContentDataStatus] = useState(null);
    const [BreifData, setBreifData] = useState([]);
    const [isExpand, setIsExpand] = useState(false);
    const [isProposalExpand, setProposalExpand] = useState(false);
    const [isEvaluationExpanded, setEvaluationExpand] = useState(false);
    const [selectedSMEvaluation, setSelectedSMEvaluation] = useState();
    const limit = OldGlobals.TXT_AREA_MAX_CHARS_LIMIT;
    const [popupState, setPopupState] = useState(null);
    const [smEvaluationData, setSmEvaluationData] = useState(null);
    const [scoreStatus, setScoreStatus] = useState("final-score-result-layout-label-status")
    const [isSubmitBtnDisabled, setSubmitBtnDisabled] = useState(true)
    const [btnClassName, setBtnClassName] = useState('disabled-apply-btn');
    const [textAreaError, setAreaError] = useState({ error: '', msg: '' });
    const [smDeadLineError, setSMDeadLineError] = useState({ error: '', msg: '' });

    const [ceDeadLineError, setCEDeadLineError] = useState({ error: '', msg: '' });
    const [toast, setToast] = useState(null);
    const [expandedCardIndex, setExpandedCardIndex] = useState({});
    const [iskeyTeamsExpanded, setKeyTeamsExpanded] = useState(false);
    const [isDraftError, setIsDraftError]=useState(false);
    const [isEvalSubmissiontError,setIsEvalSubmissiontError]=useState(false);

    const toggleCardExpansion = (index) => {
        setExpandedCardIndex((prevOpenItems) => ({
            ...prevOpenItems,
            [index]: !prevOpenItems[index],
        }))

    };


    const error = {
        textAreaError: Globals.SENIOR_MANAGER.TEXT_AREA_ERROR,
        ceDeadLineError: Globals.SENIOR_MANAGER.CE_DEADLINE_ERROR_MSG,
        smDeadLineError: Globals.SENIOR_MANAGER.SM_DEADLINE_ERROR_MSG,

    }

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);


    const handleSMEvaluationChange = (value) => {
        console.log("Ddadad");
        setSelectedSMEvaluation(value);
        //setText('');
        setCEDeadLine("");
        setSMDeadLine("");
    };

    const fetchProposalHalfPage = async () => {
        const proposalId = item.proposalId;
        try {
            let endPoint;
            const proposalDetailId = item?.proposalDetailId;//item.proposalDetails[0].proposalDetailId;

            if (proposalPage == "solicited") {
                endPoint = OldGlobals.BASE_URL + OldGlobals.ENDPOINT.CC_SOLICITED_HALF_SCREEN_MIN_DISPLAY + 'proposalId=' + proposalId + '&roleId=' + CryptoUtils.getFromLocalStorage("roleId") + '&proposalDetailId=' + proposalDetailId;

            } else if (proposalPage == "unSolicited") {
                endPoint = OldGlobals.BASE_URL + OldGlobals.ENDPOINT.CC_UNSOLICITED_HALF_SCREEN + 'proposalId=' + proposalId + '&roleId=' + CryptoUtils.getFromLocalStorage("roleId") + '&proposalDetailId=' + proposalDetailId;

            }

            const response = await axios.get(endPoint);
            return response;
        } catch (error) {
            setContentDataStatus("Error");
            console.error("Error in App component:", error);
        }
    };

    const [ceDeadLine, setCEDeadLine] = useState("");
    const [smDeadLine, setSMDeadLine] = useState("");

    const [isTouched, setIsTouched] = useState(false);
    const [isSMTouched, setIsSMTouched] = useState(false);

    const onDateChange = (name, date) => {

        if (name === "CE_EVALUATION_DEADLINE") {

            setCEDeadLine((prevData) => ({

                ...prevData,

                date,

            }));
            setSMDeadLine("");
            setInValidateMandatoryField({ isCEDateInValid: false });

            validateField1("ceEvaluation", "")

        } else {

            setSMDeadLine((prevData) => ({

                ...prevData,

                date,

            }));

            setInValidateMandatoryField({ isSMDateInValid: false });

            if (validateField1("smEvaluation", "")) {

                setBtnClassName("sm-submit-button")

                setSubmitBtnDisabled(false)

            }

        }

    };


    const handleBack = useCallback(() => {
        if (popupState === "RE_WORK" || popupState === "INVITE_TO_MANAGEMENT_PITCH" || popupState === "UNSUCCESSFUL" || popupState == "Retry" || popupState === "Draft" || popupState === "SM_DRAFT_POPUP_ERROR" || popupState === "SM_EVAL_SUBMISSION_POPUP_ERROR" || popupState =="INVITE_TO_VIRTUAL_PITCH" ) {
            submitData();
        } else {
            navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", selectedTab: proposalPage } });

        }
    }, [navigate, popupState]);

    const postDateFormat = (date) => {
        if (date) {
            return formatISO(date).split("+")[0];
        }
    };

    const submitData = () => {
        setPopupState(null);
        setIsDraftError(false);
        setIsEvalSubmissiontError(false);
        
        let requestBody = {
            proposalDetailId: item.proposalDetailId,
            status: selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK ? 9 : selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.UNSUCCESSFUL ? 7 : selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_VIRTUALPITCH ? 2: 5,
            comment: text,
            proposalId: item.proposalId,
            ...(proposalPage === "solicited" && selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK && {
                ceEvalDeadline: postDateFormat(ceDeadLine?.date),
                smEvalDeadline: postDateFormat(smDeadLine?.date)
            })
        }

        if(isDraft){
            requestBody.isDraft=true;
        }

        unSolicatedProposalUpdate(requestBody)
            .then((response) => {
                if (response.data.status === "OK") {
                    setIsDraftError(false);
                    setIsEvalSubmissiontError(false);
                    setPopupState(null);
                    if(!isDraft){
                    navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", selectedTab: proposalPage, toastValue: Globals.SENIOR_MANAGER.SUBMIT_BTN_TOAST_SUCCESS_MSG } });
                    }
                    else{
                        navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", selectedTab: proposalPage, toastValue: (roleID.toString()===OldGlobals.USER_ROLES.SNR_MGR? Globals.SM_EVAL_SAVE_AS_DRAFT_TOAST_SUCCESS_MSG:Globals.HOP_EVAL_SAVE_AS_DRAFT_TOAST_SUCCESS_MSG ) } });
                    }
                } else {
                    if (!isDraft) {
                        setIsEvalSubmissiontError(true);
                        setIsDraftError(false);
                        setPopupState("SM_EVAL_SUBMISSION_POPUP_ERROR");
                    }
                    else {
                        setIsEvalSubmissiontError(false);
                        setIsDraftError(true);
                        setPopupState("SM_DRAFT_POPUP_ERROR");
                    }
                }
            }).catch(() => {
                if (!isDraft) {
                    setIsEvalSubmissiontError(true);
                    setIsDraftError(false);
                    setPopupState("SM_EVAL_SUBMISSION_POPUP_ERROR");
                }
                else {
                    setIsDraftError(true);
                    setIsEvalSubmissiontError(false);
                    setPopupState("SM_DRAFT_POPUP_ERROR");
                }
            });


    }
    const getSMEvaluationData = () => {
        setLoading(true);

        smEvaluationProposalData(item.proposalDetailId, item.proposalId)
            .then((response) => {
                setLoading(false);

                if (response.data.status === "OK") {

                    const responseData = response.data.content.evaluationDetails;
                    setSmEvaluationData(responseData)
                    let finalScore = 0;
                    const criteriaList = [];
                    let status = ""
                    responseData.map((item) => {
                        status = item.status;

                        item.gradeEvaluations.map((gradeItem) => {
                            finalScore = finalScore + gradeItem.gradeValue;
                            if (!criteriaList.includes(gradeItem.criteriaName)) {
                                criteriaList.push(gradeItem.criteriaName)
                            }

                        })


                    })
                    setCriterias(criteriaList)
                    setScoreStatus((status === Globals.PASSED) ? "final-score-result-layout-label-status" : "final-score-result-layout-label-status-red")

                    setPopupState(null);

                } else {
                    setLoading(false)
                }
            }).catch((error) => {
                setLoading(false);

                console.error("Error in App component:", error);
                setContentDataStatus("Error");
            });

    }
    const resetStates = useCallback(() => {
        setPopupState(null);
    }, []);
    useEffect(() => {
        console.log("Popupstate when after closed ===> ", popupState);
    }, [popupState]);

    const showPopup = useCallback(
        (title, message, button1) => (
            (popupState&&<PopUp
                title={title}
                text={message}
                normalAction={popupState !== "cross" ? handleBack : null}
                normalActionText={popupState !== "cross" ? button1 : ""}
                negativeAction={popupState === "cross" ? handleBack : null}
                negativeActionText={popupState === "cross" ? button1 : ""}
                popupType="abort"
                onClose={resetStates}
                buttonBGColor={popupState !== "cross" ? "#004894" : ""}
            />)
        ),
        [handleBack, resetStates, popupState]
    );


    const handleButtonClick =
        (type) => {
            if (type === "Submit") {
                setIsDraft(false);
                setIsDraftError(false);
                if (isValidated()) {
                    if (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK) {
                        setPopupState("RE_WORK");
                    } else if (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_INMANAGEMENT_PITCH) {

                        setPopupState("INVITE_TO_MANAGEMENT_PITCH");

                    } else if (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_VIRTUALPITCH) {

                        setPopupState("INVITE_TO_VIRTUAL_PITCH");

                    }
                     else {
                        setPopupState("UNSUCCESSFUL");

                    }
                } else {
                    setPopupState("");
                }
            } else {
                if(type === "cross"){
                    setIsEvalSubmissiontError(false); 
                }
                setPopupState(type);
            }
        }
    const handleToastClose = () => {
        setToast({ isOpen: false });
    };

    const isValidated = () => {

        setPopupState(selectedSMEvaluation)
        if (text === "") {
            const newTextAreaError = { ...textAreaError, error: true, msg: Globals.SENIOR_MANAGER.TEXT_AREA_ERROR };
            setAreaError(newTextAreaError);
            setErrors({ ...errors, ["textArea"]: Globals.SENIOR_MANAGER.TEXT_AREA_ERROR });
            return false
        } else {
            if (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK) {
                if (proposalPage === "solicited") {
                    if (ceDeadLine.date === undefined || ceDeadLine.date === "") {
                        const newCEDeadLineError = { ...ceDeadLineError, error: true, msg: Globals.SENIOR_MANAGER.CE_DEADLINE_ERROR_MSG };
                        setCEDeadLineError(newCEDeadLineError);
                        setErrors({ ...errors, ["cmDeadLine"]: Globals.SENIOR_MANAGER.CE_DEADLINE_ERROR_MSG });

                    } else if (smDeadLine.date === undefined || smDeadLine.date === "") {
                        const newCEDeadLineError = { ...ceDeadLineError, error: true, msg: Globals.SENIOR_MANAGER.SM_DEADLINE_ERROR_MSG };
                        setSMDeadLineError(newCEDeadLineError);
                        setErrors({ ...errors, ["smDeadLine"]: Globals.SENIOR_MANAGER.SM_DEADLINE_ERROR_MSG });
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            }
            else {

                return true
            }

        }
        return false
    }
    const validateField1 = (fieldName, value) => {
        if (fieldName === "ceEvaluation" || fieldName === "smEvaluation") {
            const date = new Date(fieldName === "ceEvaluation" ? ceDeadLine.date : smDeadLine.date);
            if (date === undefined || date === "") {

                setErrors({ ...errors, [fieldName]: error[fieldName] });
                return false;
            } else {

                const newErrors = { ...errors };
                setErrors({ ...errors, [fieldName]: '' });
                delete newErrors[fieldName];
                setErrors(newErrors);
                return true;
            }
        } else if (!value || value.trim() === '') {
            setErrors({ ...errors, [fieldName]: error.textAreaError });
            return false;
        }
        else {
            if (proposalPage === "unSolicited") {
                setBtnClassName("sm-submit-button")
                setSubmitBtnDisabled(false)
            }
            const newErrors = { ...errors };
            setErrors({ ...errors, [fieldName]: '' });
            delete newErrors[fieldName];
            setErrors(newErrors);
            return true;
        }

    };

    useEffect(() => {
        setErrors({ ...errors, ["textArea"]: '' });
        setCEDeadLineError("");
        setSMDeadLineError("");
        if (proposalPage === "unSolicited" && text?.length === 0 && selectedSMEvaluation?.length === 0) {
            setBtnClassName("disabled-apply-btn");
            setSubmitBtnDisabled(true);
        }
        else if (proposalPage === "unSolicited" && text?.length > 0 && selectedSMEvaluation?.length > 0) {
            setBtnClassName("sm-submit-button")
            setSubmitBtnDisabled(false)
        }
    }, [selectedSMEvaluation, text]);

    useEffect(() => {
        const getProposalData = async () => {
            const proposalId = item.proposalId;
            const producerId = "612a8e8a-64af-4925-88bd-aef7893f3d55";

            try {
                const response = await fetchProposalHalfPage();
                if (response.status >= 200 && response.status < 294) {
                    setProposalData(
                        Array.isArray(response?.data?.content)
                            ? response.data.content
                            : [response?.data?.content]
                    );
                } else {
                    new Error(`API returned an error: ${response.status}`);
                }

            } catch (error) {
                setContentDataStatus("Error");

            }
        };

        getProposalData();
        getSMEvaluationData()
    }, [item]);

    useEffect(()=>{
        getDraftedSMEvalScores();
    },[])

    const handleTextAreaChange = (e) => {
        const inputText = e;//.target.value;
        const count = inputText?.length;

        if (count <= limit) {
            setText(inputText);
           // setDraftedComments(inputText)
            setCharCount(count);
        }


        if (validateField1("textArea", inputText)) {
            //setBtnClassName("sm-submit-button")
            //setSubmitBtnDisabled(false);
        }

    };
    const getData = async () => {
        try {
            setLoading(true)
            const proposalId = item.proposalId;
            const result = await fetchHalfPageBreif(
                OldGlobals.ENDPOINT.HALFPAGE_BRIEF,
                proposalId
            );
            setLoading(false)
            const {
                createdByName,
                countryName,
                productionTypeName,
                channelName,
                formatName,
                languageName,
                genreName,
                contentTypeName,
                clusterName,
                description,
                submissionRequirements,
                evalAndSelection,
                commisioningEditors,
                closingDate,
                briefTypeName,
                ceEvalDeadline,
                smEvalDeadline,
                producers
            } = result.content;
            setContentData([
                { Description: description },
                { "Submission Requirements": submissionRequirements },
                { "Evaluation Process": evalAndSelection },
            ]);
            const ceJoints = commisioningEditors.join(",");
            setBreifData([
                { name: Globals.BRIEF_DATA_KEYS["CREATED BY"], description: createdByName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["CLOSING DATE"], description: formatDate(closingDate) },
                { name: Globals.BRIEF_DATA_KEYS["CHANNEL"], description: channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["FORMAT"], description: formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["COUNTRY"], description: countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["PRODUCTION TYPE"], description: productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["SCRIPTED / \n NON-SCRIPTED"], description: contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["GENRE"], description: genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["LANGUAGE"], description: languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["CLUSTER"], description: clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS["COMMISSIONING \n EDITIORS"], description: commisioningEditors.length ? commisioningEditors.join() : Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_TYPE, description: briefTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.CE_EVALUATION_DEADLINE, description: ceEvalDeadline && formatDate(ceEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.SM_EVALUATION_DEADLINE, description: smEvalDeadline && formatDate(smEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
                { name: Globals.BRIEF_DATA_KEYS.PRODUCERS, description: producers.join(', ') || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            ])
            setData([result?.content]);

        } catch (error) {
            setLoading(false)
            console.error("Error in App component:", error);
            setContentDataStatus("Error");
        }
    };

    useEffect(() => {
        if (text?.length === 0 || selectedSMEvaluation?.length===0) {
            setSubmitBtnDisabled(true);
            setBtnClassName("disabled-apply-btn");
        }
        if (proposalPage === "solicited") {
            getData();
        }
    }, []);

    const handleReload = () => {
        getData();
    }

    const toggleSynopsis = () => {
        setIsSynopsisExpanded(!isSynopsisExpanded);
    };
    const toggleLogLine = () => {
        setIsLogLineExpanded(!isLogLineExpanded);
    };

    const toggleEpisode = () => {
        setEpisodeStructureExpanded(!isepisodeStructureExpanded);
    };
    const toggleeditorial = () => {
        setIsEditorialExpanded(!isEditorialExpanded);
    };
    const toggleBrand = () => {
        setBrandIntegrationExpanded(!isbrandIntegrationExpanded);
    };
    const toggleCompanyProfile = () => {
        setCompanyProfileExpanded(!isCompanyProfileExpanded)
    }
    const toggleCast = () => {
        setCastPresenterInfoExpanded(!iscastPresenterInfoExpanded);
    };
    const toggleLocation = () => {
        setLocationStudioInfoExpanded(!islocationStudioInfoExpanded);
    };


    const proposalStatus = proposalData?.[0]?.proposalStatusHistories
        .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0]?.status;

    const latestComment = proposalData?.[0]?.proposalStatusHistories
        .filter((item) => item.userComment)
        .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0]?.userComment;


    const handleReloadProp = () => {
        fetchProposalHalfPage();
        if (proposalPage === "solicited") {
            getData()
        }
    }

    useEffect(() => {
        if (proposalData?.[0]?.documents) {
            const allDocs = proposalData?.[0]?.documents;
            const orderedItems = [];
            const desiredOrder =
                proposalPage === "solicited"
                    ? ["LBMB", "PRSCH", "SHWRL", "CPRC", "RDOC"]
                    : ["PSH", "VP"];
            desiredOrder.forEach((docFor) => {
                const foundDoc = allDocs.find((doc) => doc.documentFor === docFor);
                let heading = "";
                switch (docFor) {
                    case "LBMB":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.LBMB;
                        break;
                    case "PRSCH":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
                        break;
                    case "SHWRL":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.SHWRL;
                        break;
                    case "CPRC":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.CPRC;
                        break;
                    case "RDOC":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.RDOC;
                        break;
                    case "PSH":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
                        break;
                    case "VP":
                        heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.VP;
                        break;
                    default:
                        heading = foundDoc?.documentType || "Document";
                }
                orderedItems.push({ foundDoc, docFor, heading, isDownload: false });
            });
            setFileItems(orderedItems);
        } else {
            setFileItems([]);
        }
    }, [proposalData]);
    const [activeIndexes, setActiveIndexes] = useState({
        brief_details: 0,
        propsal_details: 1,
    });
    const handleToggle = (category, index) => {
        setActiveIndexes((prevState) => ({
            ...prevState,
            [category]: prevState[category] === index ? null : index,
        }));
    };
    const toggleProjectStatus = () => {
        setProjectStatusExpanded(!isprojectStatusExpanded);
    };
    const toggleKeyteam = () => {
        setKeyTeamsExpanded(!iskeyTeamsExpanded);
    };

    useEffect(() => {
        if ((proposalPage === 'unsolicited' || proposalPage === "unSolicited") && text?.length === 0) {
            setSubmitBtnDisabled(true);
            setBtnClassName("disabled-apply-btn");
        }
        else if (proposalPage === 'solicited' && (text?.length === 0 && (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK && (smDeadLine.date === "" || smDeadLine.date === undefined)) || (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK && (ceDeadLine.date === "" || ceDeadLine.date === undefined)))) {
            setSubmitBtnDisabled(true);
            setBtnClassName("disabled-apply-btn");
        }
        else if (proposalPage === 'solicited' && (text?.length > 0 && (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK && (smDeadLine.date !== "" && smDeadLine.date !== undefined)) && (selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK && (ceDeadLine.date !== "" && ceDeadLine.date !== undefined)))) {
            setSubmitBtnDisabled(false);
            setBtnClassName("sm-submit-button")
        }
        else if (proposalPage === 'solicited' && (text?.length > 0 && (selectedSMEvaluation !== Globals.SENIOR_MANAGER.OPTIONS.RE_WORK))) {
            setSubmitBtnDisabled(false);
            setBtnClassName("sm-submit-button")
        }
        else if (proposalPage === 'unsolicited' && text?.length > 0) {
            setSubmitBtnDisabled(false);
            setBtnClassName("sm-submit-button")
        }
        else if (proposalPage === 'solicited' && text?.length === 0) {
            setSubmitBtnDisabled(true);
            setBtnClassName("disabled-apply-btn");
        }
    }, [text, selectedSMEvaluation, smDeadLine, ceDeadLine])

    const [inValidateMandatoryField, setInValidateMandatoryField] = useState({

        isCEDateInValid: false,

        isSMDateInValid: false

    });

    const checkForCEDate = () => {

        setIsTouched(true);

        setInValidateMandatoryField((prevState) => ({

            ...prevState,

            isCEDateInValid: (ceDeadLine === "") ? true : false

        }))

    }

    const checkForSMDate = () => {

        setIsSMTouched(true);

        setInValidateMandatoryField((prevState) => ({

            ...prevState,

            isSMDateInValid: (smDeadLine === "") ? true : false

        }))

    }

    /**Save as draft implementation */
    const isDraftEnabled= (selectedSMEvaluation!=="" && selectedSMEvaluation!== undefined) || text?.length>0 ||((selectedSMEvaluation===Globals.SENIOR_MANAGER.OPTIONS.RE_WORK) && (smDeadLine.date!=="" && smDeadLine.date!==undefined)) || ((selectedSMEvaluation===Globals.SENIOR_MANAGER.OPTIONS.RE_WORK) && (ceDeadLine.date!=="" && ceDeadLine.date!==undefined));
    const [isDraft, setIsDraft] = useState(false);
    const [draftedComments, setDraftedComments]=useState("")
    const handleSaveAsDraft = () => {
        setIsDraft(true);
        setPopupState("Draft");
        setIsEvalSubmissiontError(false);
        // if(isDraftEnabled){
        //     submitData("DRAFT");
        // }
    }

    const getDraftedSMEvalScores= async()=>{
        //if(roleID==OldGlobals.USER_ROLES.SENIOR_MANAGER){
            const response= await fetchDraftedSMEvalScores(item.proposalId,item.proposalDetailId);
            if(response.data.status==="OK" && response.data.content){
                const data=response.data.content;
                setText(data?.comment);
                setCharCount(data?.comment?.length);
                setSelectedSMEvaluation(data?.isRework?Globals.SENIOR_MANAGER.OPTIONS.RE_WORK:data?.isUnsuccessful?Globals.SENIOR_MANAGER.OPTIONS.UNSUCCESSFUL:data?.isInviteToInPersonPitch?Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_INMANAGEMENT_PITCH:data?.isInviteToInVirtualPitch?Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_VIRTUALPITCH:"");
                if(data?.isRework && proposalPage==="solicited"){
                    data?.ceEvalDeadline && onDateChange("CE_EVALUATION_DEADLINE",data.ceEvalDeadline); 
                    data?.smEvalDeadline && onDateChange("SM_EVALUATION_DEADLINE",data.smEvalDeadline);
                }
            }
    }
    return (
        <div>
            <div className="SM-Half-Page-Header-Wrapper-prop">

                <div>
                    {proposalData && proposalData?.length && (
                        <>
                            <p className="sm-unsolicated-proposal-heading">

                                {Globals.SENIOR_MANAGER.REVIEW_PROPOSAL}   <label style={{ marginLeft: 8 }}>   #</label>{proposalData?.[0]?.propRefNo}{" "}
                            </p>{" "}
                        </>
                    )}
                </div>
                <span className="SM-HalfPage-close-icon-prop" onClick={() => handleButtonClick("cross")}>
                    &times;
                </span>
            </div>
            <div className='sm-main-nav '>
                {loading ? (
                    <Loader height={50} width={50} component="ReviewProposals" />
                ) : <>
                    {proposalPage === "solicited" && <>
                        <div className="sm-proposal-unsolicated-briefs">
                            <div className={`Half ${isExpand ? 'active' : ''}`}>
                                <div
                                    className="sm-brief-expandable-header"
                                    onClick={() => { setIsExpand(!isExpand) }}
                                >
                                    <label className="sm-brief-accordion">{Globals.SENIOR_MANAGER.BRIEF_DETAILS}</label>
                                    <img
                                        className='sm-arrow'
                                        onClick={() => { setIsExpand(!isExpand) }}
                                        src={isExpand ? OldGlobals.IMG.ARROW_UP : OldGlobals.IMG.ARROW_DOWN}
                                        alt="toggle icon"
                                    />
                                </div>
                                {isExpand && (
                                    <>
                                        <div className='sm-details-ac'>
                                            {data?.length ? (
                                                <div>
                                                    {contentData?.map(
                                                        (item, index) =>
                                                            Object.values(item)[0] && (
                                                                <div key={index} className="SM-Half-Page-Content-Wrapper">
                                                                    <div className="SM-Half-Page-Desc-header1">
                                                                        {Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                                                                    </div>
                                                                    <p className="SM-Half-Page-Form-Description">
                                                                        {Object.values(item)[0]}
                                                                    </p>
                                                                </div>
                                                            )
                                                    )}

                                                    <div>
                                                        <div className="Half-Page-Form">
                                                            {BreifData?.map((item, index) => (
                                                                <div key={index} className="SM-Half-Page-Form-Fields">
                                                                    <div className="SM-Half-Page-Form-fields-Bold" style={{ whiteSpace: 'pre-line' }}>
                                                                        {item.name}
                                                                    </div>
                                                                    <div className="SM-Half-Page-Form-Description">
                                                                        {item.description}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : contentDataStatus && contentDataStatus?.length > 0 ? (
                                                <NoResultsComponent
                                                    data={{
                                                        message: Globals.HALF_PAGE_MESSAGE,
                                                        img: OldGlobals.IMG.HALF_PAGE_ERROR,
                                                        submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                                        className: 'ErrorHeader',
                                                        subclassName: 'SubError',
                                                        outerWrapper: 'HalfPageWrapper',
                                                        button: 'reload',
                                                    }}
                                                    handleReload={handleReload}
                                                />
                                            ) : (
                                                <div className="NoResultsComponent" style={{ height: '80vh' }}>
                                                    <Loader height={50} width={50} />
                                                </div>
                                            )}
                                        </div></>
                                )}
                            </div></div>
                        {proposalData && proposalData?.length ? (
                            <>
                                {/* Proposal Details layout portion */}


                                <div className="sm-proposal-unsolicated-briefs ">
                                    <div className={`Half ${isProposalExpand ? 'active' : ''}`}>

                                        <div
                                            className="sm-brief-expandable-header"
                                            onClick={() => { setProposalExpand(!isProposalExpand) }}>

                                            <label className="sm-brief-accordion"> {Globals.SOLICITED_PROPOSAL.DETAILS}</label>
                                            <img
                                                className='sm-arrow'
                                                onClick={() => { setProposalExpand(!isProposalExpand) }}
                                                src={isProposalExpand ? OldGlobals.IMG.ARROW_UP : OldGlobals.IMG.ARROW_DOWN}
                                                alt="toggle icon"
                                            />
                                        </div>

                                    </div>
                                    {isProposalExpand && (
                                        <div>
                                            <p className="sm-text-content-company">
                                                {proposalData?.[0]?.producerName}
                                                <span className="text">{ Globals.HALFSCREEN.PRESENTS}</span>
                                            </p>
                                            <div className="sm-proposal-title">
                                                {(proposalData[0]?.title || proposalData?.[0]?.projectTitle)}
                                            </div>

                                            <div className="sm-proposal-container">
                                                <div className="sm-proposal-half-page-left">
                                                    <div className="sm-proposal-heading">
                                                        {Globals.SOLICITED_PROPOSAL.LOGLINE}
                                                    </div>
                                                    <p className="sm-text-content">
                                                        {proposalData[0]?.logLine ? (
                                                            <>
                                                                {proposalData[0]?.logLine?.length > 294 ? (
                                                                    <>
                                                                        {isLogLineExpanded
                                                                            ? proposalData[0]?.logLine
                                                                            : `${proposalData[0]?.logLine.substring(0, 294)}...`}
                                                                        <div className='view'>
                                                                            <span className="sm-view-more" onClick={toggleLogLine}>
                                                                                {isLogLineExpanded ? "View Less" : "View More"}
                                                                            </span></div>
                                                                    </>
                                                                ) : (
                                                                    proposalData[0]?.logLine
                                                                )}
                                                            </>
                                                        ) : (
                                                            Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                        )}
                                                    </p>

                                                    <div className="sm-proposal-heading">
                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                                                    </div>
                                                    <p className="sm-text-content">
                                                        {proposalData[0]?.synopsis ? (
                                                            <>
                                                                {proposalData[0]?.synopsis?.length > 294 ? (
                                                                    <>
                                                                        {isSynopsisExpanded
                                                                            ? proposalData[0]?.synopsis
                                                                            : `${proposalData[0]?.synopsis.substring(0, 294)}...`}
                                                                        <div className='view'>
                                                                            <span className="sm-view-more" onClick={toggleSynopsis}>
                                                                                {isSynopsisExpanded ? "View Less" : "View More"}
                                                                            </span></div>
                                                                    </>
                                                                ) : (
                                                                    proposalData[0]?.synopsis
                                                                )}
                                                            </>
                                                        ) : (
                                                            Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                        )}
                                                    </p>

                                                    <div className="sm-unsolicated-heading">
                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.EPISODE_STRUCTURE}
                                                    </div>
                                                    <p className="sm-text-content">
                                                        {proposalData[0]?.episodeStructure ? (
                                                            <>
                                                                {proposalData[0]?.episodeStructure?.length > 294 ? (
                                                                    <>
                                                                        {isepisodeStructureExpanded
                                                                            ? proposalData[0]?.episodeStructure
                                                                            : `${proposalData[0]?.episodeStructure.substring(0, 294)}...`}
                                                                        <div className='view'>
                                                                            <span className="sm-view-more" onClick={toggleEpisode}>
                                                                                {isepisodeStructureExpanded ? "View Less" : "View More"}
                                                                            </span></div>
                                                                    </>
                                                                ) : (
                                                                    proposalData[0]?.episodeStructure
                                                                )}
                                                            </>
                                                        ) : (
                                                            Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                        )}
                                                    </p>

                                                    <div className="sm-proposal-heading">
                                                        {Globals.SOLICITED_PROPOSAL.EDITORIAL}
                                                    </div>
                                                    <p className="sm-text-content">
                                                        {proposalData[0]?.editorialDetails ? (
                                                            <>
                                                                {proposalData[0]?.editorialDetails.length > 294 ? (
                                                                    <>
                                                                        {isEditorialExpanded
                                                                            ? proposalData[0]?.editorialDetails
                                                                            : `${proposalData[0]?.editorialDetails.substring(0, 294)}...`}
                                                                        <div className='view'>
                                                                            <span className="sm-view-more" onClick={toggleeditorial}>
                                                                                {isEditorialExpanded ? "View Less" : "View More"}
                                                                            </span></div>
                                                                    </>
                                                                ) : (
                                                                    proposalData[0]?.editorialDetails
                                                                )}
                                                            </>
                                                        ) : (
                                                            Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                        )}
                                                    </p>
                                                    <div className="proposal-section">
                                                        <div className="sm-proposal-heading">
                                                            {Globals.SOLICITED_PROPOSAL.PRELIMINARY}
                                                        </div>
                                                        <p className="sm-text-content">
                                                            {proposalData[0]?.currency} {proposalData[0]?.targetBudget ?
                                                                formatCurrency(proposalData[0]?.targetBudget) : ''}
                                                        </p>
                                                    </div>
                                                    <div className="sm-unsolicated-heading">
                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION}
                                                    </div>
                                                    <p className="sm-text-content">
                                                        {proposalData[0]?.locationStudioInfo ? (
                                                            <>
                                                                {proposalData[0]?.locationStudioInfo.length > 294 ? (
                                                                    <>
                                                                        {islocationStudioInfoExpanded
                                                                            ? proposalData[0]?.locationStudioInfo
                                                                            : `${proposalData[0]?.locationStudioInfo.substring(0, 294)}...`}
                                                                        <div className='view'>
                                                                            <span className="sm-view-more" onClick={toggleLocation}>
                                                                                {islocationStudioInfoExpanded ? "View Less" : "View More"}
                                                                            </span></div>
                                                                    </>
                                                                ) : (
                                                                    proposalData[0]?.locationStudioInfo
                                                                )}
                                                            </>
                                                        ) : (
                                                            Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                        )}
                                                    </p>
                                                    <div className="sm-unsolicated-heading">
                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.CAST_PRESENTER_INFO}
                                                    </div>
                                                    <p className="sm-text-content">
                                                        {proposalData[0]?.castPresenterInfo ? (
                                                            <>
                                                                {proposalData[0]?.castPresenterInfo.length > 294 ? (
                                                                    <>
                                                                        {iscastPresenterInfoExpanded
                                                                            ? proposalData[0]?.castPresenterInfo
                                                                            : `${proposalData[0]?.castPresenterInfo.substring(0, 294)}...`}
                                                                        <div className='view'>
                                                                            <span className="sm-view-more" onClick={toggleCast}>
                                                                                {iscastPresenterInfoExpanded ? "View Less" : "View More"}
                                                                            </span></div>
                                                                    </>
                                                                ) : (
                                                                    proposalData[0]?.castPresenterInfo
                                                                )}
                                                            </>
                                                        ) : (
                                                            Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                        )}
                                                    </p>
                                                    <div className="sm-unsolicated-heading">
                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.BRAND_INTEGRATION_OPPORTUNITIES}</div>
                                                    <p className="sm-text-content">
                                                        {proposalData[0]?.brandIntegration ? (
                                                            <>
                                                                {proposalData[0]?.brandIntegration.length > 294 ? (
                                                                    <>
                                                                        {isbrandIntegrationExpanded
                                                                            ? proposalData[0]?.brandIntegration
                                                                            : `${proposalData[0]?.brandIntegration.substring(0, 294)}...`}
                                                                        <div className='view'>
                                                                            <span className="sm-view-more" onClick={toggleBrand}>
                                                                                {isbrandIntegrationExpanded ? "View Less" : "View More"}
                                                                            </span></div>
                                                                    </>
                                                                ) : (
                                                                    proposalData[0]?.brandIntegration
                                                                )}
                                                            </>
                                                        ) : (
                                                            Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                        )}
                                                    </p>
                                                    <div className="proposal-section">
                                                        <div className="sm-proposal-heading">
                                                            {Globals.SOLICITED_PROPOSAL.COMPANY}
                                                        </div>
                                                        <p className="sm-text-content last">
                                                            {proposalData[0]?.keyTeams ? (
                                                                <>
                                                                    {proposalData[0]?.keyTeams.length > 294 ? (
                                                                        <>
                                                                            {isCompanyProfileExpanded
                                                                                ? proposalData[0]?.keyTeams
                                                                                : `${proposalData[0]?.keyTeams.substring(0, 294)}...`}
                                                                            <div className='view'>
                                                                                <span className="sm-view-more" onClick={toggleCompanyProfile}>
                                                                                    {isCompanyProfileExpanded ? "View Less" : "View More"}
                                                                                </span></div>
                                                                        </>
                                                                    ) : (
                                                                        proposalData[0]?.keyTeams
                                                                    )}
                                                                </>
                                                            ) : (
                                                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>

                                                <img src={OldGlobals.IMG.LINE} alt="" />
                                                <div className="sm-proposal-right-content">
                                                    {fileItems.length > 0 ? (
                                                        <div>
                                                            {fileItems.map(({ foundDoc, docFor, heading }) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading} />)}
                                                        </div>
                                                    ) : (
                                                        <p>NA</p>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                </div>
                            </>
                        ) : contentDataStatus && contentDataStatus?.length > 0 ? (
                            <>
                                <NoResultsComponent
                                    data={{
                                        message: Globals.HALF_PAGE_MESSAGE,
                                        img: OldGlobals.IMG.HALF_PAGE_ERROR,
                                        submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                        className: "ErrorHeader",
                                        subclassName: "SubError",
                                        outerWrapper: "HalfPageWrapper",
                                        imgWrapper: "HalfPageBriefImg",
                                        button: "reload",
                                    }}
                                    handleReload={handleReloadProp}
                                />
                            </>
                        ) : (
                            <div className="NoResultsComponent" style={{ height: "80vh" }}>
                                {" "}
                                <Loader height={50} width={50} />
                            </div>
                        )

                        }</>}


                    {
                        proposalPage === "unSolicited" && <>
                            <div
                                id="review-proposal-form"
                                className="sm-proposal-unsolicated-briefs "
                            >
                                <div id="review-proposal-form-content">
                                    <div className="subHeader" key={0}>
                                        <div
                                            draggable
                                            onDragStart={(e) => e.preventDefault()}
                                            onClick={() => handleToggle("propsal_details", 0)}
                                            className="brief-expandable-header"
                                        >
                                            <label className="brief-accordion">
                                                {Globals.REVIEW_PROPOSALS.PROPOSAL_DETAILS_TITLE}
                                            </label>
                                            <img
                                                src={
                                                    activeIndexes["propsal_details"] === 0
                                                        ? OldGlobals.IMG.ARROW_UP
                                                        : OldGlobals.IMG.ARROW_DOWN
                                                }
                                                alt="toggle icon"
                                                className="arrow"
                                            />
                                        </div>
                                        {activeIndexes["propsal_details"] === 0 && (
                                            <div className="">
                                                {proposalData?.length ? <>
                                                    <div className="proposal-title">
                                                        <p className="text-content-company">
                                                            {proposalData?.[0]?.producerName}
                                                            <span className="text">{ Globals.HALFSCREEN.PRESENTS}</span>
                                                        </p>
                                                        <div className="proposal-title">
                                                            {proposalData[0]?.title ||
                                                                proposalData?.[0]?.projectTitle}
                                                        </div>
                                                    </div>

                                                    <div className="sm-proposal-container">
                                                        <div className="sm-proposal-half-page-left">
                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.COUNTRY}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.countryName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading" style={{ whiteSpace: "pre-line" }}>
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.SCRIPTED}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.contentName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.clusterName}
                                                                </div>
                                                            </div>
                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.GENRE}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.genreName}
                                                                </div>
                                                            </div>
                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.CHANNEL}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.channelName}
                                                                </div>
                                                            </div>
                                                            {proposalData[0]?.othergenre && (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.OTHERGENRE}{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.othergenre}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.LANGUAGE}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.languageName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {
                                                                        Globals.UNSOLICITED_PROPOSAL_HALF
                                                                            .PRODUCTIONTYPE
                                                                    }{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.productionTypeName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {
                                                                        Globals.UNSOLICITED_PROPOSAL_HALF
                                                                            .TARGET_AUDIENCE
                                                                    }{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.targetAudienceName}
                                                                </div>
                                                            </div>

                                                            <div className="unsolicated-proposal-text-width">
                                                                <div className="unsolicated-heading">
                                                                    {Globals.UNSOLICITED_PROPOSAL_HALF.FORMAT}{" "}
                                                                </div>
                                                                <div className="text-content-unsolicated-width">
                                                                    {proposalData[0]?.formatName}
                                                                </div>
                                                            </div>

                                                            {proposalData[0]?.noOfEpisodes ? (
                                                                <>
                                                                    <div className="unsolicated-proposal-text-width">
                                                                        <div className="unsolicated-heading">
                                                                            {
                                                                                Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                    .NOOFEPISODES
                                                                            }{" "}
                                                                        </div>
                                                                        <div className="text-content-unsolicated-width">
                                                                            {proposalData[0]?.noOfEpisodes}
                                                                        </div>
                                                                    </div>
                                                                    <div className="unsolicated-proposal-text-width">
                                                                        <div className="unsolicated-heading">
                                                                            {
                                                                                Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                    .EPDURATION
                                                                            }{" "}
                                                                        </div>
                                                                        <div className="text-content-unsolicated-width">
                                                                            {proposalData[0]?.episodeDuration}
                                                                        </div>
                                                                    </div>
                                                                    <div className="unsolicated-proposal-text-width">
                                                                        <div className="unsolicated-heading">
                                                                            {
                                                                                Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                    .TOTALEPDURATION
                                                                            }{" "}
                                                                        </div>
                                                                        <div className="text-content-unsolicated-width">
                                                                            {proposalData[0]?.totalEpisodesDuration ||
                                                                                proposalData[0]?.noOfEpisodes *
                                                                                proposalData[0]?.episodeDuration}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {
                                                                            Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                .DURATIONINMINS
                                                                        }{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.episodeDuration}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="proposal-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.synopsis ? (
                                                                    <>
                                                                        {proposalData[0]?.synopsis.length > 294 ? (
                                                                            <>
                                                                                {isSynopsisExpanded
                                                                                    ? proposalData[0]?.synopsis
                                                                                    : `${proposalData[0]?.synopsis.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleSynopsis}
                                                                                    >
                                                                                        {isSynopsisExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.synopsis
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>
                                                            <div className="proposal-heading">
                                                                {Globals.SOLICITED_PROPOSAL.LOGLINE}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.logLine ? (
                                                                    <>
                                                                        {proposalData[0]?.logLine.length > 294 ? (
                                                                            <>
                                                                                {isLogLineExpanded
                                                                                    ? proposalData[0]?.logLine
                                                                                    : `${proposalData[0]?.logLine.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleLogLine}
                                                                                    >
                                                                                        {isLogLineExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.logLine
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.TARGET_BUDGET}{" "}
                                                            </div>
                                                            <div className="text-content bottom-spacing">
                                                                {proposalData[0]?.currency}{" "}
                                                                {formatCurrency(proposalData[0]?.targetBudget)}
                                                            </div>
                                                            {/* </div> */}

                                                            <div className="unsolicated-heading">
                                                                {
                                                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                                                        .EPISODE_STRUCTURE
                                                                }
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.episodeStructure ? (
                                                                    <>
                                                                        {proposalData[0]?.episodeStructure.length >
                                                                            294 ? (
                                                                            <>
                                                                                {isepisodeStructureExpanded
                                                                                    ? proposalData[0]?.episodeStructure
                                                                                    : `${proposalData[0]?.episodeStructure.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleEpisode}
                                                                                    >
                                                                                        {isepisodeStructureExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.episodeStructure
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.locationStudioInfo ? (
                                                                    <>
                                                                        {proposalData[0]?.locationStudioInfo.length >
                                                                            294 ? (
                                                                            <>
                                                                                {islocationStudioInfoExpanded
                                                                                    ? proposalData[0]?.locationStudioInfo
                                                                                    : `${proposalData[0]?.locationStudioInfo.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleLocation}
                                                                                    >
                                                                                        {islocationStudioInfoExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.locationStudioInfo
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {
                                                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                                                        .CAST_PRESENTER_INFO
                                                                }
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.castPresenterInfo ? (
                                                                    <>
                                                                        {proposalData[0]?.castPresenterInfo.length >
                                                                            294 ? (
                                                                            <>
                                                                                {iscastPresenterInfoExpanded
                                                                                    ? proposalData[0]?.castPresenterInfo
                                                                                    : `${proposalData[0]?.castPresenterInfo.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleCast}
                                                                                    >
                                                                                        {iscastPresenterInfoExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.castPresenterInfo
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {
                                                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                                                        .BRAND_INTEGRATION_OPPORTUNITIES
                                                                }
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.brandIntegration ? (
                                                                    <>
                                                                        {proposalData[0]?.brandIntegration.length >
                                                                            294 ? (
                                                                            <>
                                                                                {isbrandIntegrationExpanded
                                                                                    ? proposalData[0]?.brandIntegration
                                                                                    : `${proposalData[0]?.brandIntegration.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleBrand}
                                                                                    >
                                                                                        {isbrandIntegrationExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.brandIntegration
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.PROJECT_STATUS}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.synopsis ? (
                                                                    <>
                                                                        {proposalData[0]?.projectStatus.length >
                                                                            294 ? (
                                                                            <>
                                                                                {isprojectStatusExpanded
                                                                                    ? proposalData[0]?.projectStatus
                                                                                    : `${proposalData[0]?.projectStatus.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleProjectStatus}
                                                                                    >
                                                                                        {isprojectStatusExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.projectStatus
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>

                                                            <div className="unsolicated-heading">
                                                                {Globals.UNSOLICITED_PROPOSAL_HALF.KEY_TEAM}
                                                            </div>
                                                            <p className="text-content">
                                                                {proposalData[0]?.keyTeams ? (
                                                                    <>
                                                                        {proposalData[0]?.keyTeams.length > 294 ? (
                                                                            <>
                                                                                {iskeyTeamsExpanded
                                                                                    ? proposalData[0]?.keyTeams
                                                                                    : `${proposalData[0]?.keyTeams.substring(
                                                                                        0,
                                                                                        294
                                                                                    )}...`}
                                                                                <div className="view">
                                                                                    <span
                                                                                        className="view-more"
                                                                                        onClick={toggleKeyteam}
                                                                                    >
                                                                                        {iskeyTeamsExpanded
                                                                                            ? "View Less"
                                                                                            : "View More"}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            proposalData[0]?.keyTeams
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                                                )}
                                                            </p>
                                                            {proposalData[0]?.artistName && (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {
                                                                            Globals.UNSOLICITED_PROPOSAL_HALF
                                                                                .ARTIST_NAME
                                                                        }{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.artistName}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {proposalData[0]?.songName && (
                                                                <div className="unsolicated-proposal-text-width">
                                                                    <div className="unsolicated-heading">
                                                                        {Globals.UNSOLICITED_PROPOSAL_HALF.SONG_NAME}{" "}
                                                                    </div>
                                                                    <div className="text-content-unsolicated-width">
                                                                        {proposalData[0]?.songName}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="unsolicated-heading">
                                                                {
                                                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                                                        .REFERENCE_LINKS
                                                                }
                                                            </div>
                                                            <div className="text-content">
                                                                {proposalData[0]?.referenceLinks &&
                                                                    proposalData[0].referenceLinks
                                                                        .split(",")
                                                                        .map((link, index) => {
                                                                            const trimmedLink = link.trim();
                                                                            const linkVariableName = `Reference Link ${index + 1
                                                                                }`;

                                                                            return (
                                                                                <span key={index} className="refflink">
                                                                                    <a
                                                                                        //href={trimmedLink}
                                                                                        href={
                                                                                            trimmedLink.startsWith("http://") ||
                                                                                                trimmedLink.startsWith("https://")
                                                                                                ? trimmedLink
                                                                                                : `http://${trimmedLink}`
                                                                                        }
                                                                                        alt={linkVariableName}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="link-value"
                                                                                    >
                                                                                        {linkVariableName}
                                                                                    </a>
                                                                                    {index <
                                                                                        proposalData[0].referenceLinks.split(
                                                                                            ","
                                                                                        ).length -
                                                                                        1 && (
                                                                                            <span className="separator">, </span>
                                                                                        )}
                                                                                </span>
                                                                            );
                                                                        })}
                                                            </div>
                                                        </div>
                                                        <img src={OldGlobals.IMG.LINE} alt="" />
                                                        <div className="proposal-right-content">
                                                            {fileItems.length > 0 ? (
                                                                <div>{fileItems.map(({ foundDoc, docFor, heading }) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading} />)}</div>
                                                            ) : (
                                                                <p>NA</p>
                                                            )}
                                                        </div>
                                                    </div></> : contentDataStatus &&
                                                        contentDataStatus?.length > 0 ? (
                                                    <NoResultsComponent
                                                        data={{
                                                            message: Globals.HALF_PAGE_MESSAGE,
                                                            img: OldGlobals.IMG.HALF_PAGE_ERROR,
                                                            submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                                            className: "ErrorHeader",
                                                            subclassName: "SubError",
                                                            outerWrapper: "HalfPageWrapper",
                                                            button: "reload",
                                                        }}
                                                        handleReload={fetchProposalHalfPage}
                                                    />
                                                ) : (
                                                    <div
                                                        className="NoResultsComponent"
                                                        style={{ height: "80vh" }}
                                                    >
                                                        <Loader height={50} width={50} />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {/* CE Evaluation portion */}
                    <div className="sm-proposal-unsolicated-briefs ">
                        <div className={`Half ${isEvaluationExpanded ? 'active' : ''}`}>
                            <div
                                className="sm-brief-expandable-header"
                                onClick={() => { setEvaluationExpand(!isEvaluationExpanded) }}
                            >

                                <label className="sm-brief-accordion">{Globals.SENIOR_MANAGER.CE_EVALUATION}</label>
                                <img
                                    className='sm-arrow'
                                    onClick={() => { setEvaluationExpand(!isEvaluationExpanded) }}
                                    src={isEvaluationExpanded ? OldGlobals.IMG.ARROW_UP : OldGlobals.IMG.ARROW_DOWN}
                                    alt="toggle icon"
                                />
                            </div>
                            {isEvaluationExpanded && (smEvaluationData?.length > 0 ? (
                                <div className='final-score-reslult-layouts'>
                                    <label className='evaluation_criteria_label'>{Globals.SENIOR_MANAGER.EVALUATION_CRITERIA}</label>
                                    <div className='sm-criteria-layout'>
                                        {criterias?.length > 0 && criterias?.map((gradeItem, index) => {

                                            return (

                                                <label key={index} className='sm-criteria-layout-text'>{gradeItem} {(criterias.length - 1) > (index) ? <p className='sm-criteria-lable-pipe'>|</p> : ""} </label>

                                            )

                                        })}
                                    </div>

                                    <div className="evaluation-list-layout">

                                        {smEvaluationData?.map((item, index) => (

                                            <div className='card-layout' key={index}>
                                                {console.log("index and item ", index + " item -->", item, "EXPANDABLE : ", expandedCardIndex[index])}

                                                <div>
                                                    <label className='ce-layout-label'>{item.ceName}</label><label className='ce-layout-label'> | </label><label className='ce-layout-label'>{Globals.SENIOR_MANAGER.EVALUATED_ON}{formatDate(item.evaluatedOn)}</label>
                                                    <div className='sm-score'>

                                                        <div className='sm-score-layout'><label className="sm-score-label">{Globals.SENIOR_MANAGER.SCORE} <label key={index} className={`${item.totalScore >= 7 ? "sm-score-value-text-green" : "sm-score-value-text-red"}`}>{item.totalScore}</label></label></div>

                                                        <div
                                                            className="score-brief-expandable-header"
                                                            onClick={() => {
                                                                toggleCardExpansion(index)
                                                            }}
                                                        >
                                                            <label className="show-score-text">{(expandedCardIndex[index]) ? Globals.SENIOR_MANAGER.HIDE_SCORE_TEXT : Globals.SENIOR_MANAGER.SHOW_SCORES_TEXT}</label>
                                                            <img
                                                                className='sm-arrow'
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); // Stop the event from bubbling up to the div
                                                                    toggleCardExpansion(index);
                                                                }}

                                                                src={(expandedCardIndex[index]) ? OldGlobals.IMG.ARROW_UP : OldGlobals.IMG.ARROW_DOWN}
                                                                alt="toggle icon"
                                                            />
                                                        </div>

                                                    </div>
                                                    {/* Rattings layout: */}
                                                    {expandedCardIndex[index] &&


                                                        <div className='rating-root-layout' key={index}>
                                                            {item.gradeEvaluations.map((gradeItem, gradeIndex) => {
                                                                return (
                                                                    <div className='ratings-layout'>

                                                                        <label className='ratings-text' key={gradeIndex}>{gradeItem.criteriaName} : {gradeItem.gradeValue}</label>

                                                                    </div>
                                                                )

                                                            })}

                                                        </div>
                                                    }

                                                    <div>
                                                        <label className="show-score-description-text">{item.comments}</label>

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='final-score-reslult-layout'>
                                        <label className='final-score-reslult-layout-label'>{Globals.SENIOR_MANAGER.FINAL_SCORE}{smEvaluationData?.[0]?.finalScore}
                                        </label>
                                        <label className='final-score-reslult-layout-label'>{Globals.SENIOR_MANAGER.SCORING_STATUS}<label className={scoreStatus}>{smEvaluationData?.[0]?.status}</label></label>
                                    </div>
                                </div>
                            ) : contentDataStatus && contentDataStatus?.length > 0 ? (
                                <NoResultsComponent
                                    data={{
                                        message: Globals.HALF_PAGE_MESSAGE,
                                        img: OldGlobals.IMG.HALF_PAGE_ERROR,
                                        submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                        className: 'ErrorHeader',
                                        subclassName: 'SubError',
                                        outerWrapper: 'HalfPageWrapper',
                                        button: 'reload',
                                    }}
                                    handleReload={getSMEvaluationData}
                                />
                            ) : (
                                <div className="NoResultsComponent" style={{ height: '80vh' }}>
                                    <Loader height={50} width={50} />
                                </div>
                            )

                            )

                            }
                            {proposalStatus && [3, 5, 6].includes(proposalStatus) && latestComment && (
                                <div className="sm-status-comments">
                                    <p className="sm-unsolicated-proposal-comments">Comments</p>
                                    <p className="sm-comment-unsolicated">{latestComment}</p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Senior manager evalutation portion */}
                    <div className="sm-proposal-unsolicated-briefs ">
                        <div className="Half ">
                            <div
                                className="sm-brief-expandable-header" >
                                <label className="brief-accordion-sm-title">{roleID.toString() === OldGlobals.USER_ROLES.SNR_MGR ? Globals.SENIOR_MANAGER.SM_EVALUATION : Globals.HOP_EVALUATION}</label>

                            </div>

                            <div className="sm-proposal-status ">
                                <HorizontalOptionButtons onChange={handleSMEvaluationChange} selectedOption={selectedSMEvaluation} isVirtualPitch={isVirtualPitchCompleted}></HorizontalOptionButtons>
                                {selectedSMEvaluation &&
                                    <div id="popup-email">
                                        <div className='sm-text-area-style'>
                                            <div id="logline-holder">
                                                <label id="logline-label" className="physical-address">{Globals.SENIOR_MANAGER.COMMENTS}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                                                </label>
                                            </div>

                                                <TextArea
                                                    value={text}
                                                    placeHolder={Globals.SM_EVAL_COMMENTS_PLACEHOLDER}
                                                    textAreaInput={handleTextAreaChange}
                                                    className={"comment-area-style"}
                                                    noCharCounterNeeded={true}
                                                    clearText={text?true:false}
                                                />
                                            <div className='sm-text-area-error-layout'>
                                                <div>
                                                    <p className='comment-area-limit-layout'>
                                                        {errors.textArea &&
                                                            <div className='sm-text-area-error-msg-layout'><img src={OldGlobals.IMG.ERROR} alt="password error" /><span>{errors.textArea}</span>

                                                            </div>
                                                        }
                                                        <div className='sm-text-area-lable-count'><label className='sm-text-area-count-text'>  {charCount}/{limit}</label></div>
                                                    </p>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                }
                                {(selectedSMEvaluation === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK && proposalPage === "solicited") ?
                                    <div className='comments-layout'>
                                        <div className='ce_evaluation_layout'>
                                            <span tabIndex={-1} onBlur={checkForCEDate}>
                                                <BriefDateDropdown

                                                    inputLabel={Globals.SENIOR_MANAGER.CE_EVALUATION_DEADLINE}

                                                    name="CE_EVALUATION_DEADLINE"

                                                    placeholderText=" "

                                                    minDate={new Date()}

                                                    onDateChange={onDateChange}

                                                    selectedDate={ceDeadLine.date}

                                                />
                                            </span>

                                            {(isTouched && inValidateMandatoryField.isCEDateInValid) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.CE_EVAL_DEADLINE}</label></div>}
                                        </div> <div className='ce_evaluation_layout'>
                                            <span tabIndex={-1} onBlur={checkForSMDate}>
                                                <BriefDateDropdown

                                                    inputLabel={Globals.SENIOR_MANAGER.SM_EVALUATION_DEADLINE}

                                                    name={"SM_EVALUATION_DEADLINE"}

                                                    placeholderText=" "

                                                    disabled={!ceDeadLine?.date}

                                                    minDate={ceDeadLine?.date}

                                                    onDateChange={onDateChange}

                                                    selectedDate={smDeadLine.date}

                                                />
                                            </span>

                                            {(isSMTouched && inValidateMandatoryField.isSMDateInValid) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.SM_EVAL_DEADLINE}</label></div>}
                                        </div>

                                    </div>

                                    : <></>}

                            </div>


                        </div></div>
                </>}
            </div>
            <div className="Half-Page-Close-Apply-Btn-Wrapper smevaluationpage">
                <div className="SM-Half-Page-Close-Apply">
                    <div className="SM-Half-Page-Close-Text" onClick={() => {handleButtonClick("cross")}}>
                        {Globals.CLOSE}
                    </div>
                    {console.log("isDraftEnabled",isDraftEnabled)}
                    <div>
                        <button id="review-proposal-draft-btn" disabled={!isDraftEnabled} className={"review-proposal-draft-btn-active"} onClick={handleSaveAsDraft}>{Globals.APPLY_BRIEF.SAVE_AS_DRAFT}</button>
                    </div>
                    <Button
                        title={Globals.SENIOR_MANAGER.SUBMIT_BTN_TEXT}
                        id="sm-half-page-cc-re-assign-proposal"
                        additionalStyle={btnClassName}
                        disable={isSubmitBtnDisabled}
                        action={() => {
                            handleButtonClick("Submit");

                        }}
                    />

                </div>
            </div>
            {(!isDraft&&popupState) &&
                showPopup(
                    Globals.SENIOR_MANAGER.POPUP[popupState].TITLE,
                    Globals.SENIOR_MANAGER.POPUP[popupState].DESCRIPTION,
                    Globals.SENIOR_MANAGER.POPUP[popupState].BUTTON_TEXT,
                )}
            {(isDraft&&popupState) &&
                showPopup(
                    Globals.SM_DRAFT_POPUP.TITLE,
                    Globals.SM_DRAFT_POPUP.DESCRIPTION,
                    Globals.SM_DRAFT_POPUP.BUTTON_TEXT,
                )}
            {(isDraftError && popupState) &&
                showPopup(
                    Globals.SM_DRAFT_POPUP_ERROR.TITLE,
                    Globals.SM_DRAFT_POPUP_ERROR.DESCRIPTION,
                    Globals.SM_DRAFT_POPUP_ERROR.BUTTON_TEXT,
                )}
            {(isEvalSubmissiontError && popupState) &&
                showPopup(
                    Globals.SM_EVAL_SUBMISSION_POPUP_ERROR.TITLE,
                    Globals.SM_EVAL_SUBMISSION_POPUP_ERROR.DESCRIPTION,
                    Globals.SM_EVAL_SUBMISSION_POPUP_ERROR.BUTTON_TEXT,
                )}

            {toast?.isOpen && (
                <Toast
                    status={toast?.status}
                    onClose={handleToastClose}
                    title={toast?.title}
                />
            )}
        </div>
    );
}